<template>
  <b-modal
    id="payment_method_course_dlg"
    ref="payment_method_course_dlg"
    title="Phương thức thanh toán"
    hide-footer
  >
    <div class="body-modal">
      <label class="radio">
        Thanh toán bằng chuyển khoản
        <input
          v-model="paymentMethod"
          class="form-check-input"
          type="radio"
          name="payment_method"
          value="3"
        >
        <span class="checkround" />
      </label>
      <label class="radio">
        Thanh toán bằng MoMo
        <input
          v-model="paymentMethod"
          class="form-check-input"
          type="radio"
          name="payment_method"
          value="2"
        >
        <span class="checkround" />
      </label>
      <label class="radio">
        Thanh toán bằng ViettelPay
        <input
          v-model="paymentMethod"
          class="form-check-input"
          type="radio"
          name="payment_method"
          value="4"
        >
        <span class="checkround" />
      </label>
      <label class="radio">
        Thanh toán bằng VTCPay
        <input
          v-model="paymentMethod"
          class="form-check-input"
          type="radio"
          name="payment_method"
          value="9"
        >
        <span class="checkround" />
      </label>
    </div>

    <div>
      <button 
        class="btn btn-order btn-success" 
        @click="order()">Chọn</button>
    </div>
  </b-modal>
</template>

<script>
import rf from "../../communicate/RequestFactory";
import { errorToaster } from "../../services/ErrorHandler";

export default {
  name: "PaymentMethodCourseDialog",
  props: ["course"],
  data() {
    return {
      paymentMethod: 9
    };
  },
  methods: {
    order() {
      const data = {
        payment_method: this.paymentMethod,
        phone: "",
        product_code: this.course.product_code
      };

      this.$Progress.start();
      rf.getRequest("OrderRequest")
        .orderCourse(data)
        .then(res => {
          if (res.status === 200) {
            const req = {
              order_id: res.data.order_id,
              order_code: res.data.order_code,
              customer_number: res.data.receiver_phone,
              description: `Thanh toan don hang ${res.data.order_code}`,
              payment_method: res.data.payment_method,
              amount: res.data.total_amount,
              payment_type: 0
            };
            this.$Progress.finish();
            this.requestVietel(req);
          }
          errorToaster("Cố vấn Phong Thủy", "Xảy ra lỗi kết nối");
          this.$Progress.fail();
        })
        .catch(err => {
          errorToaster("Cố vấn Phong Thủy", "Xảy ra lỗi kết nối");
          this.$Progress.fail();
        });
    },

    requestVietel(req) {
      rf.getRequest("OrderRequest")
        .viettelPayCourse(req)
        .then(res => {
          if (res.status === 200) {
            window.location.href = res.data;
          }
        })
        .catch(err => {
          errorToaster("Cố vấn Phong Thủy", "Xảy ra lỗi kết nối");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#payment_method_course_dlg {
  .body-modal {
    padding: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/course/PaymentMethodCourseDialog.vue